module.exports = __webpack_public_path__ + "img/qiandai_icon.706a412a.png";